import React, { useState, useEffect, useCallback } from "react";
import { Field, Form, Formik } from "formik";
import { useHistory } from 'react-router-dom';
import * as moment from "moment";
import { FORMAT } from "web/components/utils/dateOfBirthValidation";
import { getPostInitialValues, VALIDATION_SCHEMA, } from "web/components/utils/requestOrdersUtils";
import { adminFetchLocationListApi } from "redux/actions/adminPtPlusOrderRequests";
import { fetchLocationListApi } from 'redux/actions/adminPtPlus/index';

import CloseIcon from "web/assets/images/CloseIcon.png";
import { useDispatch, useSelector } from 'react-redux';
import AlertModal from "web/components/AlertModal";
import RecurringOrderModal from "web/components/RecurringOrderModal";
import Breadcrumb from "web/components/Breadcrumb";
import UploadSpecificationPTPLUS from "web/components/UploadSpecificationPTPLUS";
import LoadDetails from "web/pages/private/CommonPages/PtPlus/RequestOrder/loadDetails"
import NumberInput from "web/components/form-elements/NumberInput";
import RadioButton from "web/components/form-elements/RadioButton";
import TextArea from "web/components/form-elements/TextArea";
import { Tooltip } from 'reactstrap';
import information from "web/assets/images/notification-blue.png";
import CheckboxInput from "web/components/form-elements/CheckboxInput";
import TextInput from "web/components/form-elements/TextInput";
import DropDown from "web/components/DropDown";
import Select from "web/components/form-elements/Select";
import Layout from "web/components/Layout";
import Button from "web/components/Button";
import Spinner from 'web/components/Spinner';
import TooltipMaterial from "@material-ui/core/Tooltip";
import UploadDummy from "web/assets/images/UploadDummy.png";
import styled from 'styled-components';
import { Container, Wrapper, TopHeader, Footer, FormWrapper, UploadSpec, InputFieldsWrapper } from "./OrderStyled"
import HeadingIcon from "web/assets/svg/RequestOrderIcon"
import { logoutClearRedux } from 'redux/actions/auth';

import {
  uploadSpectFilePTMS,
  createOrder,
  updateRequestedOrder,
  orderRefNumber,
  palletDetails
} from "redux/actions/adminPtPlus";


const OrderRequest = (props) => {
  const token = localStorage.getItem("token")
  let history = useHistory()
  const dispatch = useDispatch();
  const adminRoles = useSelector(state => state.admin.adminRoles)
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
  const storedData = useSelector((state) => state.storedData.payload);
  const [companyName, setSelectCompanyName] = useState();
  const [locationName, setLocationName] = useState();

  const [quantityValueState, setQuantityValueState] = useState(540);
  const [maxQuantityState, setMaxQuantityState] = useState(540);
  const [recurringModal, setRecurringModal] = useState(false)

  const [filesArr, setFilesArr] = useState();
  const [addresResponse, setAddresResponse] = useState();
  const [gradeState, setGradeState] = useState();
  const customerId = localStorage.getItem("locationID")
  const equipmentList = ["Flatbed", "Enclosed Trailer", "Straight Truck"]
  const [loadDetailsState, setLoadDetailsState] = useState();

  let hardOrSoftWoodArray = ['New - Hardwood', 'New - Softwood']
  const [hardOrSoftWoodValue, setHardOrSoftWoodValue] = useState('')
  const [productPostImage, setDefaultPostImage] = useState();

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const toggleModal = () => setModal(!modal);
  const [successCreateOrder, setSuccessCreateOrder] = useState(false);

  const [cloneOrderFlag, setCloneOrderFlag] = useState(false);
  const [palletDetailResponse, setPalletDetailResponse] = useState();

  useEffect(() => {
    if (!token) {
      history.push('./sign-in')
      window.location.reload(false);
    } else {
      fetchMyAPI()
    }
  }, []);
  const fetchMyAPI = useCallback(async () => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink("/");
      toggleModal();
    } else {
      let response = await dispatch(palletDetails(token));

      if (response?.success) {
        setPalletDetailResponse(response?.data)
        locationListAPI(response?.data)
      } else {
        if (response?.data?.error.message === "Invalid Token") {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response?.data?.error?.message || response.message || 'Something went wrong, please try again!');
          setModalLink("");
          toggleModal();
        }
      }
    }
  }, []);
  const businessNameList = [
    {
      label: "",
      value: "",
    },
  ];

  const removeRecurringSettingFunction = (formikSetFieldValueFunction) => {
    formikSetFieldValueFunction('recurringCheckBoxFlag', false)

    let requestDeliveryDate = moment(new Date().setDate(new Date().getDate() + 4)).format(FORMAT)
    let requestStartDateRecOrder = moment(new Date().setDate(new Date().getDate() + 2)).format(FORMAT)
    let requestEndDateRecOrder = moment(new Date().setDate(new Date().getDate() + 30)).format(FORMAT)
    formikSetFieldValueFunction('recTypeTemp', 'WEEKLY')
    formikSetFieldValueFunction('recStartDateTemp', requestStartDateRecOrder)
    formikSetFieldValueFunction('recEndDateTemp', requestEndDateRecOrder)
    formikSetFieldValueFunction('weeklyRecEveryTemp', 1)
    formikSetFieldValueFunction('weeklyRecDaysTemp', [])
    formikSetFieldValueFunction('monthlyRecTypeTemp', 'DAY')
    formikSetFieldValueFunction('monthlyDayTypeRecDayTemp', 1)
    formikSetFieldValueFunction('monthlyDayTypeRecEveryTemp', 1)
    formikSetFieldValueFunction('monthlyCustomeTypeStartDateOfWeekTemp', 'FIRST')
    formikSetFieldValueFunction('monthlyCustomeTypeStarWeektDayOfWeekTemp', 'MONDAY')
    formikSetFieldValueFunction('monthlyCustomeTypeRecEveryTemp', 1)

    formikSetFieldValueFunction(`addMoreArrList.[${0}].requestDeliveryDate`, requestDeliveryDate)
    formikSetFieldValueFunction(`addMoreArrList.[${0}].appt`, '00:00')
    formikSetFieldValueFunction(`addMoreArrList.[${0}].apptTo`, "23:00")
    formikSetFieldValueFunction(`apptEdit`, '00:00')
    formikSetFieldValueFunction(`apptToEdit`, "23:00")
  }

  const frameRecurringOrderSummary = (data) => {
    function capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }
    function getWeekDaysInSequence(a, b) {
      const daysOrder = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
      return daysOrder.indexOf(a) - daysOrder.indexOf(b);
    }
    let recTypeValue = capitalizeFirstLetter(data.recType || '')
    let recValuesText = ''
    if (data.recType === 'WEEKLY') {
      let weeklyDaysTemp = data.weeklyRecDays?.map(data => `${capitalizeFirstLetter(data).substring(0, 3)}`)
      weeklyDaysTemp = weeklyDaysTemp?.sort(getWeekDaysInSequence)
      recValuesText = `Every ${weeklyDaysTemp} for 
              ${data.weeklyRecEvery} week(s), Starting ${moment(data.recStartDate).format('MM/DD/YYYY')}, Ending ${moment(data.recEndDate).format('MM/DD/YYYY')}`
    } else if (data.recType === 'MONTHLY') {
      if (data.monthlyRecType === 'DAY') {
        recValuesText = `Day ${data.monthlyDayTypeRecDay} for every ${data.monthlyDayTypeRecEvery} month(s), 
              Starting ${moment(data.recStartDate).format('MM/DD/YYYY')}, Ending ${moment(data.recEndDate).format('MM/DD/YYYY')}`
      } else if (data.monthlyRecType === 'CUSTOM') {
        recValuesText = `${capitalizeFirstLetter(data.monthlyCustomeTypeStartDateOfWeek)} ${capitalizeFirstLetter(data.monthlyCustomeTypeStarWeektDayOfWeek).substring(0, 3)} 
              for every ${data.monthlyCustomeTypeRecEvery} month(s), Starting ${moment(data.recStartDate).format('MM/DD/YYYY')}, Ending ${moment(data.recEndDate).format('MM/DD/YYYY')}`
      }
    }
    return `${recTypeValue}: ${recValuesText}`
  }

  const [tooltip, setTooltip] = useState(false);
  const [tooltipSection, setTooltipSection] = useState('');
  const iIcon = (infoSection, infoTxt) => {
    return <>
      <img
        id={infoSection}
        src={information}
        style={{ position: "relative", top: "2px", left: '-5px' }}
        alt="information"
      />
      <Tooltip
        placement="top"
        isOpen={tooltip && tooltipSection === infoSection}
        target={infoSection}
        toggle={() => {
          setTooltip(!tooltip)
          setTooltipSection(tooltipSection === '' ? infoSection : '')
        }
        }
      >
        {infoTxt}
      </Tooltip>
    </>
  }


  const [alertType, setAlertType] = useState();
  const [editResponse, setEditResponse] = useState();
  const [uploadSpectState, setUploadSpectState] = useState();
  const formSubmit = async (props) => {
    if (props.values.addMoreArrList.length !== 0) {
      for (let i = 0; i < props.values.addMoreArrList.length; i++) {
        let fromTimeValue = parseInt(props.values.addMoreArrList[i].appt?.replace(":", ""));
        let toTimeValue = parseInt(props.values.addMoreArrList[i].apptTo?.replace(":", ""));
        if (toTimeValue < fromTimeValue) {
          setModalContent("Appointment window time is invalid.")
          setModalLink("");
          toggleModal();
          return false;
        }
      }
    }
    if ((props?.values?.grade === "Custom" || props?.values?.size === "Custom" || props?.values?.material === "OTHER" || props?.values?.material === "PLASTIC") && (!props?.values?.length || !props?.values?.width || !props?.values?.height)) {
      setModalContent("size is a required field. Please populate and resubmit.");
      setModalLink("");
      toggleModal();
    } else if (!companyName) {
      setModalContent("Company name is a required field. Please populate and resubmit.");
      setModalLink("");
      toggleModal();
    }
    // else if (!locationName) {
    //   setModalContent("location name is a required field. Please populate and resubmit.");
    //   setModalLink("");
    //   toggleModal();
    // }
    else if (props?.values?.size !== "Custom" && gradeState?.length && !props?.values?.grade) {
      setModalContent("Grade is a required field. Please populate and resubmit.");
      setModalLink("");
      toggleModal();
    }
    else {
      if (filesArr && filesArr.length !== 0) {
        let formData = new FormData();
        for (let i = 0; i < filesArr.length; i++) {
          formData.append("file", filesArr[i]);
        }
        let response = await dispatch(uploadSpectFilePTMS(formData, token));

        if (response?.success) {
          let s3FilesArr = []
          for (let i = 0; i < response?.data?.s3UploadedFiles.length; i++) {
            let obj = {
              orignalFileName: response?.data?.s3UploadedFiles[i].fileName,
              fileName: response?.data?.s3UploadedFiles[i].s3FfileName
            }
            s3FilesArr.push(obj)
            if (response?.data?.s3UploadedFiles.length - 1 === i) {
              setUploadSpectState(s3FilesArr)
              submitApi(props, s3FilesArr)
            }
          }
        } else {
          setModalContent(response?.data?.error?.message || response.message || 'Something went wrong, please try again!');
          setModalLink("");
          toggleModal();
        }
      } else {
        if (props?.values?.size === "Custom" && editResponse?.data?.specificationFiles.length === 0) {
          setModalContent("Upload specification is a required field. Please populate and resubmit.");
          setModalLink("");
          toggleModal();
        } else {
          if (uploadSpectState && uploadSpectState.length !== 0) {
            let arr = []
            for (let i = 0; i < uploadSpectState.length; i++) {
              if (uploadSpectState[i].label) {
                let obj = {
                  orignalFileName: uploadSpectState[i].label,
                  fileName: uploadSpectState[i].value
                }
                arr.push(obj)
              }

              if (uploadSpectState.length - 1 === i) {
                setUploadSpectState(arr)
                submitApi(props, arr)
              }
            }
          } else {
            submitApi(props)
          }
        }
      }
    }
  }

  const submitApi = async (props, spectFiles) => {

    let conditionArr = [];
    if (props?.values?.condition0) {
      conditionArr.push("RECYCLED");
    }
    if (props?.values?.condition1) {
      conditionArr.push("NEW");
    }
    if (props?.values?.condition2) {

      conditionArr.push("COMBO");
    }
    if (props?.values?.condition3) {
      conditionArr = []
      conditionArr.push("CORES");
    }

    if (conditionArr.length === 0 && props?.values?.material !== "OTHER") {
      setModalContent("Condition is a required field. Please populate and resubmit.");
      setModalLink("");
      toggleModal();
      return false;
    }
    else if (props?.values?.material === "WOOD" && !props?.values?.palletType) {
      setModalContent("Pallet Type is a required field. Please populate and resubmit.");
      setModalLink("");
      toggleModal();
      return false;
    } else if (getMoisture.length !== 0 && !props?.values?.moisture) {
      setModalContent("Moisture is a required field. Please populate and resubmit.");
      setModalLink("");
      toggleModal();
      return false;
    }
    else if (props?.values?.material === "WOOD" && props?.values?.palletType && !props?.values?.size) {
      setModalContent("Size is a required field. Please populate and resubmit.");
      setModalLink("");
      toggleModal();
      return false;
    } else if (getGradeList.length !== 0 && !props?.values?.grade) {
      setModalContent("Grade is a required field. Please populate and resubmit.");
      setModalLink("");
      toggleModal();
      return false;
    }
    if (props?.values?.cloneOrder && !props?.values?.orderId) {
      setModalContent("Order Id is a required field. Please populate and resubmit.");
      setModalLink("");
      toggleModal();
      return false;
    }

    let equipmentRequirements = []
    if (props.values.equipment0) {
      equipmentRequirements.push("FLAT_BED")
    } if (props.values.equipment1) {
      equipmentRequirements.push("ENCLOSED_TRAILER")
    } if (props.values.equipment2) {
      equipmentRequirements.push("STRAIGHT_TRUCK")
    }

    if (equipmentRequirements.length === 0) {
      setModalContent("Equipment is a required field. Please populate and resubmit.");
      setModalLink("");
      toggleModal();
      return false;
    }

    let loadDetailsArr = []
    if (props.values.addMoreArrList.length !== 0 && props.values.addMoreArrList[0].lots && props.values.addMoreArrList[0].QuantityLot) {
      for (let i = 0; i < props.values.addMoreArrList.length; i++) {
        if (props.values.addMoreArrList[i].lots && props.values.addMoreArrList[i].QuantityLot) {
          let obj = {
            requestDeliveryDate: moment(props.values.addMoreArrList[i].requestDeliveryDate).format('YYYY-MM-DD HH:mm'),
            deliveryFromtime: props.values.addMoreArrList[i].appt,
            deliveryTotime: props.values.addMoreArrList[i].apptTo || props.values.apptTo,
            lotType: props?.values?.lotsOption,

            poNumber: props.values.addMoreArrList[i].poNumber,

            postType: "NEED",
            quantityDetails: {
              lots: parseInt(props.values.addMoreArrList[i].lots),
              quantity: props.values.addMoreArrList[i].QuantityLot,
              originalQuantity: props.values.quantityMaxValue
              // props.values.addMoreArrList[0].QuantityLot//
            },
          }
          loadDetailsArr.push(obj)
        } else {
          if (!props.values.addMoreArrList[i].lots) {
            setModalContent("Number of loads is a required field. Please populate and resubmit.");
            setModalLink("");
            toggleModal();
            return false
          }
          if (!props.values.addMoreArrList[i].QuantityLot) {
            setModalContent("Quantity per loads is a required field. Please populate and resubmit.");
            setModalLink("");
            toggleModal();
            return false
          }
        }
      }

      // creating object for recurring order
      let recurranceObject = null
      if (props.values?.recurringCheckBoxFlag) {
        recurranceObject = {
          recType: props.values?.recTypeTemp,
          startDate: props.values?.recStartDate,
          endDate: props.values?.recEndDate,
          pattern: {
            weekly: {},
            monthly: {}
          }
        }
        if (props.values?.recTypeTemp === 'WEEKLY') {
          recurranceObject.pattern.monthly = null
          recurranceObject.pattern.weekly.recuringEvery = props.values?.weeklyRecEvery
          recurranceObject.pattern.weekly.weekdays = props.values?.weeklyRecDays
        } else if (props.values?.recTypeTemp === 'MONTHLY') {
          recurranceObject.pattern.weekly = null
          recurranceObject.pattern.monthly.monthlyType = props.values.monthlyRecType
          recurranceObject.pattern.monthly.dayType = {}
          recurranceObject.pattern.monthly.custom = {}
          if (props.values.monthlyRecType === 'DAY') {
            recurranceObject.pattern.monthly.custom = null
            recurranceObject.pattern.monthly.dayType.recuringDay = props.values?.monthlyDayTypeRecDay
            recurranceObject.pattern.monthly.dayType.recuringEvery = props.values?.monthlyDayTypeRecEvery
          } else if (props.values.monthlyRecType === 'CUSTOM') {
            recurranceObject.pattern.monthly.dayType = null
            recurranceObject.pattern.monthly.custom.weekOfMonth = props.values?.monthlyCustomeTypeStartDateOfWeek
            recurranceObject.pattern.monthly.custom.reccuringWeek = props.values?.monthlyCustomeTypeStarWeektDayOfWeek
            recurranceObject.pattern.monthly.custom.recuringEvery = props.values?.monthlyCustomeTypeRecEvery
          }
        }
      }

      let data = {
        palletDetails: {
          material: props?.values?.material,
          condition: props?.values?.material === "OTHER" ? [] : conditionArr,
          // newHardware:props?.values?.newHardware || "",
          palletType: props?.values?.material === "OTHER" || props?.values?.material === "PLASTIC" ? "CUSTOM" : props?.values?.palletType ? props?.values?.palletType.toUpperCase() : "CUSTOM",
          moisture: props?.values?.material === "OTHER" || props?.values?.material === "PLASTIC" ? "" : props?.values?.moisture,
          size: props?.values?.size,
          grade: props?.values?.grade,
          length: props?.values?.length || "", //parseInt(props?.values?.length)
          width: props?.values?.width || "", //props?.values?.width
          height: props?.values?.height || "",//parseInt(props?.values?.height) 
          heatTreared: props.values.isHeatTreared,
        },
        specificationFiles: spectFiles && spectFiles.length !== 0 ? spectFiles : uploadSpectState && uploadSpectState.length !== 0 ? uploadSpectState : uploadImageStage ? uploadImageStage : [],
        productImage: productPostImage ? [productPostImage] : null,
        // Location Name & Address
        orderRefNumber: "",
        equipmentRequirements: equipmentRequirements,
        loadDetails: loadDetailsArr,
        location: {
          locationId: locationName || "",
          shippingAddress: {
            name: locationAddress?.name,
            contactNumber: locationAddress?.contactNumber || "(213) 456-7811",
            locationName: locationAddress?.locationName ? locationAddress?.locationName : locationAddress?.name,
            street: locationAddress?.street,
            city: locationAddress?.city,
            state: locationAddress?.state,
            zipCode: locationAddress?.zipCode,
            locationDaysOfOperations: []
          }
        },
        isCreatedByAdmin: true,
        remark: props?.values?.remark,
        customer: {
          customerId: companyName,
          ptUser: true,
          customerName: localStorage.getItem('userName')
        },
        postRecurring: props.values?.recurringCheckBoxFlag,
        recurrance: recurranceObject
      }

      if (conditionArr?.includes('NEW') && props.values?.hardOrSoftWood !== '') {
        data.palletDetails.newConditionType = props.values?.hardOrSoftWood === 'New - Hardwood' ? 'HARDWOOD' : 'SOFTWOOD'
      }

      if (!token) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        let response
        response = await dispatch(createOrder(data, token));

        if (response?.success) {
          setModalTitle("")
          setModalContent("Order request created successfully.");
          setModalLink("");
          toggleModal();
          setAlertType("success")
        } else {
          setAlertType()
          setModalContent(response?.data?.error?.message || response?.message || 'Something went wrong, please try again!');
          setModalLink("");
          toggleModal();
        }
      }
    } else {
      setAlertType()
      setModalContent("Number of loads is a required field. Please populate and resubmit.");
      setModalLink("");
      toggleModal();
      return false;
    }
  }
  const formFilledBasedOnResponseId = (referenceResponse, props, setFieldValue, editFlag) => {
    // For Conditions
    if (referenceResponse?.palletDetails?.condition && referenceResponse?.palletDetails?.condition.length !== 0) {
      for (let i = 0; i < referenceResponse?.palletDetails?.condition.length; i++) {
        if (referenceResponse?.palletDetails?.condition[i] === "RECYCLED") {
          setFieldValue("condition0", true)
        } if (referenceResponse?.palletDetails?.condition[i] === "NEW") {
          setFieldValue("condition1", true)
        } if (referenceResponse?.palletDetails?.condition[i] === "COMBO") {
          setFieldValue("condition2", true)
        } if (referenceResponse?.palletDetails?.condition[i] === "CORES") {
          setFieldValue("condition3", true)
          setFieldValue("condition0", false)
          setFieldValue("condition1", false)
          setFieldValue("condition2", false)
        }
      }
      if (referenceResponse?.palletDetails?.newConditionType === 'HARDWOOD') {
        setFieldValue("hardOrSoftWood", 'New - Hardwood')
        setHardOrSoftWoodValue('New - Hardwood')
      } else if (referenceResponse?.palletDetails?.newConditionType === 'SOFTWOOD') {
        setFieldValue("hardOrSoftWood", 'New - Softwood')
        setHardOrSoftWoodValue('New - Softwood')
      }
    }

    for (let j = 0; j < referenceResponse?.equipmentRequirements.length; j++) {
      if (referenceResponse?.equipmentRequirements[j] === "FLAT_BED") {
        setFieldValue("equipment0", true)
      } if (referenceResponse?.equipmentRequirements[j] === "ENCLOSED_TRAILER") {
        setFieldValue("equipment1", true)
      } if (referenceResponse?.equipmentRequirements[j] === "STRAIGHT_TRUCK") {
        setFieldValue("equipment2", true)
      }
    }

    let palletType = referenceResponse?.palletDetails?.palletType?.toLowerCase()
    if (palletType === "euro" || referenceResponse?.palletDetails?.palletType === "EUROPALLET") {
      palletType = "euroPallet"
    }
    setMaterialResponse(referenceResponse?.palletDetails?.material)
    setFieldValue("palletType", palletType)

    setFieldValue("material", referenceResponse?.palletDetails?.material)
    setFieldValue("moisture", referenceResponse?.palletDetails?.moisture)
    setFieldValue("size", referenceResponse?.palletDetails?.size)
    setFieldValue("grade", referenceResponse?.palletDetails?.grade)

    let fileArr = []
    for (let i = 0; i < referenceResponse?.specificationFiles.length; i++) {
      const fileObject =
      {
        label: referenceResponse?.specificationFiles[i]?.orignalFileName,
        value: referenceResponse?.specificationFiles[i]?.fileName,
      }

      fileArr.push(fileObject)
      if (i === referenceResponse?.specificationFiles.length - 1) {
        setUploadImage(fileArr)
        setUploadSpectState(fileArr)
      }
    }

    setFieldValue("length", referenceResponse?.palletDetails?.length)
    setFieldValue("width", referenceResponse?.palletDetails?.width)
    setFieldValue("height", referenceResponse?.palletDetails?.height)

    if (referenceResponse?.palletDetails?.condition && referenceResponse?.palletDetails?.condition[0] !== "CORES") {
      setIsHeatTreared(true)
    }
    if (referenceResponse?.palletDetails?.material === "OTHER") {
      setIsHeatTreared(false)
    }

    setFieldValue("isHeatTreared", referenceResponse?.palletDetails?.heatTreared)

    setFieldValue("addMoreArrList.[0].lots", referenceResponse?.loadDetails?.quantityDetails?.lots)
    setFieldValue("addMoreArrList.[0].QuantityLot", referenceResponse?.loadDetails?.quantityDetails?.quantity)
    setFieldValue("quantityMaxValue", referenceResponse?.loadDetails?.quantityDetails?.quantityMaxValue)

    const clonedOrderDate = moment(referenceResponse?.loadDetails.requestDeliveryDate);
    const today = moment().startOf('day');
    const validDate = clonedOrderDate.isAfter(today) ? clonedOrderDate : moment().add(1, 'day');
    setFieldValue("addMoreArrList.[0].requestDeliveryDate", validDate.format("MM/DD/YYYY"));

    setFieldValue("addMoreArrList.[0].appt", referenceResponse.loadDetails.deliveryFromtime)
    setFieldValue("addMoreArrList.[0].apptTo", referenceResponse.loadDetails.deliveryTotime)

    if (referenceResponse?.loadDetails?.quantityDetails?.originalQuantity) {
      setMaxQuantityState(referenceResponse?.loadDetails?.quantityDetails?.originalQuantity)
    }

    if (referenceResponse?.recurrence) {
      setFieldValue("recurringCheckBoxFlag", true)

      setFieldValue("recType", referenceResponse?.recurrence?.recType)
      setFieldValue("weeklyRecEvery", referenceResponse?.recurrence?.pattern?.weekly?.recuringEvery)
      setFieldValue("weeklyRecDays", referenceResponse?.recurrence?.pattern?.weekly?.weekdays)

      if (referenceResponse?.recurrence?.pattern?.monthly?.monthlyType)
        setFieldValue("monthlyRecType", referenceResponse?.recurrence?.pattern?.monthly?.monthlyType)

      if (referenceResponse?.recurrence?.pattern?.monthly?.dayType?.recuringDay)
        setFieldValue("monthlyDayTypeRecDay", referenceResponse?.recurrence?.pattern?.monthly?.dayType?.recuringDay)

      if (referenceResponse?.recurrence?.pattern?.monthly?.dayType?.recuringEvery)
        setFieldValue("monthlyDayTypeRecEvery", referenceResponse?.recurrence?.pattern?.monthly?.dayType?.recuringEvery)

      if (referenceResponse?.recurrence?.pattern?.monthly?.custom?.weekOfMonth)
        setFieldValue("monthlyCustomeTypeStartDateOfWeek", referenceResponse?.recurrence?.pattern?.monthly?.custom?.weekOfMonth)

      if (referenceResponse?.recurrence?.pattern?.monthly?.custom?.reccuringWeek)
        setFieldValue("monthlyCustomeTypeStarWeektDayOfWeek", referenceResponse?.recurrence?.pattern?.monthly?.custom?.reccuringWeek)

      if (referenceResponse?.recurrence?.pattern?.monthly?.custom?.recuringEvery)
        setFieldValue("monthlyCustomeTypeRecEvery", referenceResponse?.recurrence?.pattern?.monthly?.custom?.recuringEvery)

      setFieldValue("weeklyRecDays", referenceResponse?.recurrence?.pattern?.weekly?.weekdays)
      setFieldValue("weeklyRecEveryTemp", referenceResponse?.recurrence?.pattern?.weekly?.weekdays)


      setFieldValue("recTypeTemp", referenceResponse?.recurrence?.recType)
      setFieldValue("weeklyRecEveryTemp", referenceResponse?.recurrence?.pattern?.weekly?.recuringEvery)
      setFieldValue("weeklyRecDaysTemp", referenceResponse?.recurrence?.pattern?.weekly?.weekdays)
      setFieldValue("monthlyRecTypeTemp", referenceResponse?.recurrence?.pattern?.monthly?.monthlyType)
      setFieldValue("monthlyDayTypeRecDayTemp", referenceResponse?.recurrence?.pattern?.monthly?.dayType?.recuringDay)
      setFieldValue("monthlyDayTypeRecEveryTemp", referenceResponse?.recurrence?.pattern?.monthly?.dayType?.recuringEvery)
      if (referenceResponse?.recurrence?.pattern?.monthly?.custom?.weekOfMonth)
        setFieldValue("monthlyCustomeTypeStartDateOfWeekTemp", referenceResponse?.recurrence?.pattern?.monthly?.custom?.weekOfMonth)

      if (referenceResponse?.recurrence?.pattern?.monthly?.custom?.reccuringWeek)
        setFieldValue("monthlyCustomeTypeStarWeektDayOfWeekTemp", referenceResponse?.recurrence?.pattern?.monthly?.custom?.reccuringWeek)

      if (referenceResponse?.recurrence?.pattern?.monthly?.custom?.recuringEvery)
        setFieldValue("monthlyCustomeTypeRecEveryTemp", referenceResponse?.recurrence?.pattern?.monthly?.custom?.recuringEvery)
    }

    // setFieldValue("addMoreArrList.[0].requestDeliveryDate",moment(new Date(referenceResponse?.data.loadDetails.requestDeliveryDate * 1000).toLocaleString()).format(FORMAT))
    // setFieldValue("addMoreArrList.[0].appt", referenceResponse?.loadDetails.deliveryFromtime)
    setFieldValue("addMoreArrList.[0].poNumber", referenceResponse?.loadDetails?.poNumber)


    setFieldValue("lots", referenceResponse?.loadDetails?.quantityDetails?.lots)
    setFieldValue("QuantityLot", referenceResponse?.loadDetails?.quantityDetails?.quantity)
    // setFieldValue("TotalQuantity", response?.quantityDetails?.totalQuantity)

    setFieldValue("businessName", referenceResponse?.location?.locationId)
    setFieldValue("poNumber", referenceResponse?.loadDetails?.poNumber)

    //setFieldValue("requestDeliveryDate",  moment(new Date(referenceResponse?.data.loadDetails.requestDeliveryDate * 1000).toLocaleString()).format(FORMAT))
    //setFieldValue("appt", referenceResponse?.data?.loadDetails?.deliveryFromTime)
    let arr = []
    arr.push(referenceResponse?.loadDetails)
    setLoadDetailsState(arr)
    // setFieldValue("deliveryWindowBegin", editResponse?.deliveryFromTime)
    // setFieldValue("deliveryWindowEnd", editResponse?.deliveryToTime)

    // setAppointmentState(editResponse?.appointmentType)
    // setFieldValue("poNumber", editResponse?.poNumber)
    // setFieldValue("appointment", editResponse?.appointmentType)
    palletTypeData(props, palletType, editFlag, referenceResponse)
  }

  const woodConditions = ["Recycled", "New", "Combo"]
  const plasticConditions = ["Recycled", "New"]
  const [newHardwareResponse, setNewHardwareResponse] = useState("hardware");

  const [materialResponse, setMaterialResponse] = useState("WOOD");
  const [getLotsOption, setLotsOption] = useState("MULTIPLE");

  const [getMoisture, setMoisture] = useState([]);
  const [getSizeList, setSizeList] = useState([]);
  const [getGradeList, setGradeList] = useState([]);
  const [uploadImageStage, setUploadImage] = useState();
  const [isHeatTrearedFlag, setIsHeatTreared] = useState(false);

  const orderRefNumberAPI = async (refNumber, props, setFieldValue) => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink("/");
      toggleModal();
    } else {
      let response = await dispatch(orderRefNumber(refNumber, token));

      if (response?.success) {
        if (response?.data) {
          formFilledBasedOnResponseId(response?.data, props, setFieldValue, true)
          let obj = {
            label: response?.data?.data?.shippingAddress?.name,
            value: response?.data?.data?.location?.locationId,
            response: response?.data?.data?.shippingAddress
          }
          setAddresResponse(obj)
          setEditResponse(response?.data)

          if (response?.data?.shippingAddress)
            setLocationAddress(response?.data?.shippingAddress)

          setSelectCompanyName(response?.data?.customer?.customerId)

          for (let j = 0; j < companyNameResponse.length; j++) {
            if (response?.data?.customer?.customerId === companyNameResponse[j].value) {
              let arr = [];
              if (companyNameResponse[j]?.arrList.length !== 0) {
                for (let i = 0; i < companyNameResponse[j]?.arrList.length; i++) {
                  let obj = {
                    label: `${companyNameResponse[j]?.arrList[i].locationName} - ${companyNameResponse[j]?.arrList[i].city}, ${companyNameResponse[j]?.arrList[i].state}, ${companyNameResponse[j]?.arrList[i].zip}`,
                    value: companyNameResponse[j]?.arrList[i].locationId,
                  };
                  arr.push(obj);
                  if (i === companyNameResponse[j]?.arrList.length - 1) {
                    setLocationListResponse(arr)
                    setLocationName(response?.data?.location?.locationId)
                  }
                }
              }
            }
          }

          // setMaterialResponse(response?.data?.data?.palletDetails?.material)
          // setFieldValue("material", response?.data?.data?.palletDetails?.material)
          // setFieldValue("moisture", response?.data?.data?.palletDetails?.moisture)
          // setFieldValue("size", response?.data?.data?.palletDetails?.size)
          // setFieldValue("grade", response?.data?.data?.palletDetails?.grade)

          // let fileArr=[]
          // for(let i=0;i<response?.data?.data?.specificationFiles.length;i++){
          //   const fileObject =
          //   {
          //     label: response?.data?.data?.specificationFiles[i]?.orignalFileName,
          //     value: response?.data?.data?.specificationFiles[i]?.fileName,
          //   }

          //   fileArr.push(fileObject)
          //   if(i === response?.data?.data?.specificationFiles.length-1){
          //     setUploadImage(fileArr)
          //     setUploadSpectState(fileArr)
          //   }
          // }  


          // setFieldValue("length", response?.data?.data?.palletDetails?.length)
          // setFieldValue("width", response?.data?.data?.palletDetails?.width)
          // setFieldValue("height", response?.data?.data?.palletDetails?.height)

          // if (response?.data?.data?.palletDetails?.condition[0] !== "CORES") {
          //   setIsHeatTreared(true)
          // }
          //setFieldValue("isHeatTreared", response?.data?.data?.palletDetails?.heatTreared)
          // setFieldValue("lots", response?.data?.data?.loadDetails?.quantityDetails?.lots)
          // setFieldValue("QuantityLot", response?.data?.data?.loadDetails?.quantityDetails?.quantity)
          // setFieldValue("TotalQuantity", response?.data?.data?.quantityDetails?.totalQuantity)

          //setFieldValue("businessName", response?.data?.data?.location?.locationId)
          // setFieldValue("requestDeliveryDate", editResponse?.data?.requestDeliveryDate)
          // setFieldValue("deliveryWindowBegin", editResponse?.data?.deliveryFromTime)
          // setFieldValue("deliveryWindowEnd", editResponse?.data?.deliveryToTime)

          // setAppointmentState(editResponse?.data?.appointmentType)
          // setFieldValue("poNumber", editResponse?.data?.poNumber)
          // setFieldValue("appointment", editResponse?.data?.appointmentType)
        } else {
          setAddresResponse(response)
        }
      } else {
        if (response?.data?.error?.message === "Invalid Token") {
          //navigate("/")
        } else {
          setModalContent(response?.data?.error?.message);
          setModalLink("");
          toggleModal();
        }
      }
    }
  };
  const selectComapnyName = [
    {
      label: "",
      value: "",
    },
  ];
  const [locationListResponse, setLocationListResponse] = useState();
  const [companyNameResponse, setCompanyNameResponse] = useState(selectComapnyName);
  const locationListAPI = useCallback(async (palletResponse) => {
    if (token === null) {
      history.push('./sign-in')
      window.location.reload(false);
    } else {
      let response = await dispatch(adminFetchLocationListApi(customerId, token));
      if (response?.success) {
        let locationTemp = response?.data?.customerAndLocations;
        let arr = [];
        for (let i = 0; i < locationTemp.length; i++) {
          let obj = {
            label: locationTemp[i].customer + ' - ' + locationTemp[i].city + ', ' + locationTemp[i].state + ', ' + locationTemp[i].zip,
            value: locationTemp[i].customerId,
            arrList: locationTemp[i].locationIdAndNames
          };
          arr.push(obj);

          if (i === locationTemp.length - 1) {
            setCompanyNameResponse(arr)

            // if (urlObject?.id) {
            //   orderRefNumberAPI(urlObject?.id, arr, palletResponse)
            // }
          }
        }
      } else {
        setModalContent(response?.data?.error?.message || response.message || 'Something went wrong, please try again!');
        setModalLink("");
        toggleModal();
      }
    }
  }, []);

  const [locationAddress, setLocationAddress] = useState();
  const [getLocationAddressState, setLocationAddressState] = useState();
  const getLocationAddress = async (customerId) => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink("/");
      toggleModal();
    } else {
      let response = await dispatch(fetchLocationListApi(customerId, token));
      let arr = []
      if (response?.success) {
        if (response?.data?.locations[0]?.mainLocation) {
          let obj = {
            locationId: response?.data?.locations[0]?.mainLocation?.locationId,
            address: response?.data?.locations[0]?.mainLocation?.address
          }
          arr.push(obj)
        }
        if (response?.data?.locations[0]?.subLocations) {
          for (let i = 0; i < response?.data?.locations[0]?.subLocations.length; i++) {
            let obj = {
              locationId: response?.data?.locations[0]?.subLocations[i]?.locationId,
              address: response?.data?.locations[0]?.subLocations[i]?.address
            }
            arr.push(obj)
          }
        }
        setLocationAddressState(arr)


      } else {
        setModalContent(response?.data?.error?.message);
        setModalLink("");
        toggleModal();
      }
    }
  }

  const materialArr = [
    {
      id: "0",
      label: "Wood",
      value: "WOOD",
    },
    {
      id: "1",
      label: "Plastic",
      value: "PLASTIC",
    },
    {
      id: "2",
      label: "Other",
      value: "OTHER",
    },
  ];
  let palletList = [
    {
      label: "Block",
      value: "block",
      id: 0,
    },
    {
      label: "Stringer",
      value: "stringer",
      id: 1,
    },
    {
      label: "Euro Pallet",
      value: "euroPallet",
      id: 2,
    },
    {
      label: "Crate",
      value: "crate",
      id: 3,
    },
    {
      label: "Tray",
      value: "tray",
      id: 4,
    },
    {
      label: "Other",
      value: "other",
      id: 5,
    }
  ]
  let comboPalletList = [
    {
      label: "Stringer",
      value: "stringer",
      id: 1,
    },
    {
      label: "Crate",
      value: "crate",
      id: 2,
    },
    {
      label: "Custom",
      value: "custom",
      id: 3,
    }
  ]
  let corePalletList = [
    {
      label: "Block",
      value: "block",
      id: 0,
    },
    {
      label: "Stringer",
      value: "stringer",
      id: 1,
    }
  ]
  const materialDiv = (setFieldValue) => {
    return (
      <>
        {/* <div className="label-heading"><p>Pallet Details<span className="star">*</span></p></div> */}
        <div className="col-5 text-left mb-40">
          <p className="sec-label">Material</p>
          <div className="row">
            {materialArr?.map((value, index) => (
              <div key={index} className="col-4">
                <Field
                  component={RadioButton}
                  name="material"
                  id={value.value}
                  defaultValue={materialResponse}
                  onSelect={(e) => {
                    //uploadSpecificationFiles(props)
                    setSizeList([])
                    setGradeList([])
                    setMoisture([])
                    setFieldValue("palletType", "")
                    setFieldValue("moisture", "")
                    setFieldValue("size", "")
                    setFieldValue("grade", "")
                    setIsHeatTreared(false)
                    setFieldValue("condition0", false)
                    setFieldValue("condition1", false)
                    setFieldValue("condition2", false)
                    setFieldValue("condition3", false)
                    setFieldValue("hardOrSoftWood", '');
                    setFieldValue("length", "")
                    setFieldValue("width", "")
                    setFieldValue("height", "")
                    setFieldValue("isHeatTreared", false)

                    setUploadSpectState()
                    setIsHeatTreared(false)
                    if (e.target.value === "PLASTIC") {
                      setFieldValue("addMoreArrList.[0].QuantityLot", 786)
                      setFieldValue('quantityMaxValue', 786)
                      setMaxQuantityState(786)
                    } else {
                      setFieldValue("addMoreArrList.[0].QuantityLot", 540)
                      setFieldValue('quantityMaxValue', 540)
                      setMaxQuantityState(540)
                    }
                    // if (props.values.addMoreArrList.length !== 0) {
                    //   for (let i = 0; i < props.values.addMoreArrList.length; i++) {
                    //    setFieldValue("addMoreArrList.["+i+"].QuantityLot", 540)
                    //   }
                    // } 
                    setUploadImage()
                    setDefaultPostImage()
                    setMaterialResponse(e.target.value)
                    //clearFileds()
                  }}
                  label={value.label}
                />
              </div>
            ))}
          </div>
        </div></>
    );
  };
  const conditions = (setFieldValue, arrList) => {
    return (
      <div className="text-left  mb-40">
        <p className="sec-label">Condition</p>
        <div className="row condition-styles">
          {arrList?.map((value, index) => (
            <div style={{ width: '130px', marginLeft: '15px' }} key={index}>
              <CheckboxInput
                name={"condition" + index}
                label={arrList[index]}
                // disabled={props?.values?.condition3 ? true : false}
                onChange={(val, label) => {
                  setSizeList([])
                  setGradeList([])
                  setMoisture([])
                  setDefaultPostImage()
                  setUploadImage()
                  setFieldValue("palletType", "")
                  setFieldValue("moisture", "")
                  setFieldValue("size", "")
                  setFieldValue("grade", "")
                  setFieldValue("length", "")
                  setFieldValue("width", "")
                  setFieldValue("height", "")
                  setFieldValue("isHeatTreared", false)
                  setIsHeatTreared(false)

                  setFieldValue("condition0", false)
                  setFieldValue("condition1", false)
                  setFieldValue("condition2", false)
                  setFieldValue("condition3", false)
                  setFieldValue("hardOrSoftWood", '');

                  if (label === "Recycled" && val)
                    setFieldValue("condition0", true)

                  if (label === "New" && val)
                    setFieldValue("condition1", true)

                  if (label === "Combo" && val)
                    setFieldValue("condition2", true)

                  if (label === "Cores" && val)
                    setFieldValue("condition3", true)

                  // if (label === "Cores" && val) {
                  //   setFieldValue("condition0", false)
                  //   setFieldValue("condition1", false)
                  //   setFieldValue("condition2", false)
                  // } else {
                  //   setFieldValue("condition3", false)
                  // }
                }}
              />
            </div>
          ))}
        </div>
      </div>
    );
  };

  const hardOrSoftWoodDiv = (setFieldValue) => {
    return (
      <div className="row condition-styles">
        {hardOrSoftWoodArray &&
          hardOrSoftWoodArray.map((value, index) => (
            <HardSoftWoodWrapper>
              <Field
                component={RadioButton}
                name="hardOrSoftWood"
                id={value}
                defaultValue={hardOrSoftWoodArray[0]}
                onSelect={(e) => {
                  let tempValue = hardOrSoftWoodValue === e.target?.value ? '' : e.target?.value
                  setFieldValue('hardOrSoftWood', tempValue)
                  setHardOrSoftWoodValue(tempValue)
                }}
                label={value}
              />
            </HardSoftWoodWrapper>
          ))}
      </div>
    );
  };

  const sizeArrayList = (props, palletType, editFlag, referenceResponse, palletResponse) => {
    if (palletType === "europallet") {
      palletType = "euroPallet"
    }
    let selectedMaterial = props?.values?.material.toLowerCase()
    let conditionTypes = []
    if (editFlag && referenceResponse?.palletDetails?.condition && referenceResponse?.palletDetails?.condition.length !== 0) {
      if (referenceResponse?.palletDetails?.condition) {
        for (let i = 0; i < referenceResponse?.palletDetails?.condition.length; i++) {
          if (referenceResponse?.palletDetails?.condition[i] === "RECYCLED") {
            conditionTypes.push("recycled")
          } if (referenceResponse?.palletDetails?.condition[i] === "NEW") {
            conditionTypes.push("newCondition")
          } if (referenceResponse?.palletDetails?.condition[i] === "COMBO") {
            conditionTypes.push("combo")
          } if (referenceResponse?.palletDetails?.condition[i] === "CORES") {
            conditionTypes.push("cores")
          }
        }
      }
      selectedMaterial = referenceResponse?.palletDetails?.material.toLowerCase()
    } else {
      if (props?.values?.condition0) {
        conditionTypes.push("recycled")
      }
      if (props?.values?.condition1) {
        conditionTypes.push("newCondition")
      }
      if (props?.values?.condition2) {
        conditionTypes.push("combo")
      }
      if (props?.values?.condition3) {
        conditionTypes.push("cores")
      }
    }

    let palletResponseSet = palletDetailResponse
    if (!palletDetailResponse && palletResponse) {
      palletResponseSet = palletResponse
    }

    let sizeArr = []
    for (let j = 0; j < conditionTypes.length; j++) {
      let response = palletResponseSet[selectedMaterial].condition[conditionTypes[j]][palletType]


      setIsHeatTreared(false)
      if (response?.palletSpecificDetails.length !== 0) {
        for (let i = 0; i < response?.palletSpecificDetails.length; i++) {
          if (response?.palletSpecificDetails[i]?.size !== '') {
            const sizeObject =
            {
              label: response?.palletSpecificDetails[i]?.size,
              value: response?.palletSpecificDetails[i]?.size,
              quantity: response?.palletSpecificDetails[i]?.quantity,
            }

            sizeArr.push(sizeObject)
          }

          if (response?.palletSpecificDetails.length - 1 === i) {
            if (conditionTypes.length - 1 === j) {
              if (sizeArr.length === 0) {
                gradeArrayList(props, palletType, editFlag, referenceResponse)
              }
              else {
                if (referenceResponse?.palletDetails?.grade) {
                  gradeArrayList(props, palletType, editFlag, referenceResponse, palletResponse)
                }
              }
            }

            const sizeNames = sizeArr.map(val => val.value)
            const sizeListFilter = sizeArr.filter(({ value }, index) => !sizeNames.includes(value, index + 1))

            setSizeList(sizeListFilter)
          }
        }
      }
    }
  }
  const gradeArrayList = (props, palletType, editFlag, referenceResponse, palletResponse) => {
    let selectedMaterial = props?.values?.material.toLowerCase()
    let conditionTypes = []
    if (editFlag && referenceResponse?.palletDetails?.condition && referenceResponse?.palletDetails?.condition.length !== 0) {
      if (referenceResponse?.palletDetails?.condition) {
        for (let i = 0; i < referenceResponse?.palletDetails?.condition.length; i++) {
          if (referenceResponse?.palletDetails?.condition[i] === "RECYCLED") {
            conditionTypes.push("recycled")
          } if (referenceResponse?.palletDetails?.condition[i] === "NEW") {
            conditionTypes.push("newCondition")
          } if (referenceResponse?.palletDetails?.condition[i] === "COMBO") {
            conditionTypes.push("combo")
          } if (referenceResponse?.palletDetails?.condition[i] === "CORES") {
            conditionTypes.push("cores")
          }
        }
      }

      selectedMaterial = referenceResponse?.palletDetails?.material.toLowerCase()
    } else {
      if (props?.values?.condition0) {
        conditionTypes.push("recycled")
      }
      if (props?.values?.condition1) {
        conditionTypes.push("newCondition")
      }
      if (props?.values?.condition2) {
        conditionTypes.push("combo")
      }
      if (props?.values?.condition3) {
        conditionTypes.push("cores")
      }
    }

    let palletResponseSet = palletDetailResponse
    if (!palletDetailResponse && palletResponse) {
      palletResponseSet = palletResponse
    }
    let gradeArr = []
    for (let j = 0; j < conditionTypes.length; j++) {
      let response = palletResponseSet[selectedMaterial].condition[conditionTypes[j]][palletType]
      if (response?.palletSpecificDetails.length !== 0) {
        for (let i = 0; i < response?.palletSpecificDetails.length; i++) {
          if (response?.palletSpecificDetails[i]?.grade !== '') {
            const gradeObject =
            {
              label: response?.palletSpecificDetails[i]?.grade,
              value: response?.palletSpecificDetails[i]?.grade,
            }

            gradeArr.push(gradeObject)
          }

          if (response?.palletSpecificDetails.length - 1 === i) {
            const gradeNames = gradeArr.map(val => val.value)
            const gradeListFilter = gradeArr.filter(({ value }, index) => !gradeNames.includes(value, index + 1))
            setGradeList(gradeListFilter)
          }
        }
      } else {
        setMoisture([])
        setSizeList([])
      }
    }
  }
  const palletType = (props, setFieldValue) => {
    return (
      <div className="app-input-text mb-26">
        <Select
          name="palletType"
          data={props?.values?.condition2 ? comboPalletList : props?.values?.condition3 ? corePalletList : palletList}
          placeholder={"Pallet Type"}
          disabled={!props?.values?.condition0 && !props?.values?.condition1 && !props?.values?.condition2 && !props?.values?.condition3 ? true : false}
          searchable={true}
          onChangeHandler={(val) => {
            let palletType = val.value
            //clearFileds()
            setUploadImage()
            setDefaultPostImage()
            setGradeList([])
            setFieldValue("palletType", "")
            setFieldValue("moisture", "")
            setFieldValue("size", "")
            setFieldValue("grade", "")
            setIsHeatTreared(false)
            if (palletType === "europallet") {
              palletType = "euroPallet"
            }
            palletTypeData(props, palletType)
          }}
        />
      </div>
    );
  };

  const palletTypeData = (props, palletType, editFlag, referenceResponse, palletResponse) => {
    let moistureArr = []
    let conditionTypes = []
    let selectedMaterial = props?.values?.material?.toLowerCase()
    if (editFlag && referenceResponse?.palletDetails?.condition && referenceResponse?.palletDetails?.condition.length !== 0) {
      for (let i = 0; i < referenceResponse?.palletDetails?.condition.length; i++) {
        if (referenceResponse?.palletDetails?.condition[i] === "RECYCLED") {
          conditionTypes.push("recycled")
        } if (referenceResponse?.palletDetails?.condition[i] === "NEW") {
          conditionTypes.push("newCondition")
        } if (referenceResponse?.palletDetails?.condition[i] === "COMBO") {
          conditionTypes.push("combo")
        } if (referenceResponse?.palletDetails?.condition[i] === "CORES") {
          conditionTypes.push("cores")
        }
      }
      selectedMaterial = referenceResponse?.palletDetails?.material.toLowerCase()
    } else {
      if (props?.values?.condition0) {
        conditionTypes.push("recycled")
      }
      if (props?.values?.condition1) {
        conditionTypes.push("newCondition")
      }
      if (props?.values?.condition2) {
        conditionTypes.push("combo")
      }
      if (props?.values?.condition3) {
        conditionTypes.push("cores")
      }
    }

    if (palletType === "custom") {
      const sizeObject = [
        {
          label: "Custom",
          value: "Custom",
        }
      ]
      setSizeList(sizeObject)
    }
    if (palletType === "europallet") {
      palletType = "euroPallet"
    }
    let palletResponseSet = palletDetailResponse
    if (!palletDetailResponse && palletResponse) {
      palletResponseSet = palletResponse
    }
    for (let j = 0; j < conditionTypes.length; j++) {
      let response = palletResponseSet[selectedMaterial].condition[conditionTypes[j]][palletType]

      if (response?.palletSpecificDetails.length !== 0) {
        for (let i = 0; i < response?.palletSpecificDetails.length; i++) {
          if (response?.palletSpecificDetails[i]?.moisture !== '') {
            const moistureObject =
            {
              label: response?.palletSpecificDetails[i]?.moisture,
              value: response?.palletSpecificDetails[i]?.moisture,
            }
            moistureArr.push(moistureObject)
          }

          if (response?.palletSpecificDetails.length - 1 === i) {
            const moistureNames = moistureArr.map(val => val.value)
            const moistureArrListFilter = moistureArr.filter(({ value }, index) => !moistureNames.includes(value, index + 1))
            setMoisture(moistureArrListFilter)
            if (conditionTypes.length - 1 === j) {
              if (moistureArr.length === 0) {
                // if (urlObject?.id) {
                //   sizeArrayList(props, palletType, editFlag, referenceResponse, palletResponse)
                // } else {
                // sizeArrayList(props, palletType)
                // }

                if (referenceResponse) {
                  sizeArrayList(props, palletType, editFlag, referenceResponse, palletResponse)
                } else {
                  sizeArrayList(props, palletType)
                }

              } else {
                //(editResponse || editFlag) && sizeArrayList(props, palletType, editFlag, referenceResponse)
                if (editResponse || editFlag) {
                  sizeArrayList(props, palletType, editFlag, referenceResponse, palletResponse)
                }
              }


            }
          }
        }
      } else {
        setMoisture([])
        setSizeList([])
      }
    }


  }

  const moisture = (props) => {
    return (
      <div className="app-input-text mb-26">
        <Select
          name="moisture"
          data={getMoisture}
          placeholder={"Moisture"}
          disabled={getMoisture.length === 0 ? true : false}
          searchable={true}
          onChangeHandler={() => {
            setIsHeatTreared(false)
            setUploadImage()
            setDefaultPostImage()
            let palletType = props?.values?.palletType
            sizeArrayList(props, palletType)
          }}
        />
      </div>
    );
  };

  const size = (props, setFieldValue) => {
    return (
      <div className="app-input-text mb-26">
        <Select
          name="size"
          data={getSizeList}
          placeholder={"Size"}
          disabled={getSizeList.length === 0 ? true : false}
          searchable={true}
          onChangeHandler={(val, data) => {
            setGradeList([])
            setUploadImage()
            setDefaultPostImage()
            setFieldValue("grade", "")
            setFieldValue("length", "")
            setFieldValue("width", "")
            setFieldValue("height", "")
            uploadSpecificationFiles(props, false)

            if (val?.quantity) {
              setMaxQuantityState(parseInt(val?.quantity))
              setQuantityValueState(val?.quantity)
              setFieldValue("addMoreArrList.[0].QuantityLot", val?.quantity);
              setFieldValue('quantityMaxValue', val?.quantity)

              let quantity = props?.values?.lots * val?.quantity;
              let radixPos = String(quantity).indexOf(".");
              if (radixPos !== -1) {
                quantity = parseInt(quantity) + parseInt(1);
              }
              if (quantity === 0) {
                quantity = ""
              }
              setFieldValue("TotalQuantity", quantity);
            }

            if (props.values.condition3) {
              setIsHeatTreared(false)
            } else {
              setIsHeatTreared(true)
            }
            let gradeArr = []
            let filesArr = []
            let conditionTypes = []
            if (props?.values?.condition0) {
              conditionTypes.push("recycled")
            }
            if (props?.values?.condition1) {
              conditionTypes.push("newCondition")
            }
            if (props?.values?.condition2) {
              conditionTypes.push("combo")
            }
            if (props?.values?.condition3) {
              conditionTypes.push("cores")
            }

            const selectedMaterial = props?.values?.material.toLowerCase()
            let palletType = props?.values?.palletType.toLowerCase()
            if (palletType === "europallet") {
              palletType = "euroPallet"
            }

            let response = palletDetailResponse[selectedMaterial].condition[conditionTypes[0]][palletType]

            for (let i = 0; i < response?.palletSpecificDetails.length; i++) {
              if (val.value === response?.palletSpecificDetails[i]?.size) {
                if (response?.palletSpecificDetails[i]?.grade !== '') {
                  const gradeObject =
                  {
                    label: response?.palletSpecificDetails[i]?.grade,
                    value: response?.palletSpecificDetails[i]?.grade,
                  }
                  gradeArr.push(gradeObject)
                }
                if (props?.values?.moisture === response?.palletSpecificDetails[i]?.moisture) {
                  if (response?.palletSpecificDetails[i]?.file !== '' && response?.palletSpecificDetails[i]?.file !== "Custom Spec Upload") {
                    const fileObject =
                    {
                      label: response?.palletSpecificDetails[i]?.file,
                      value: response?.palletSpecificDetails[i]?.file,
                    }

                    filesArr.push(fileObject)
                  }
                } else {
                  if (!props?.values?.moisture && response?.palletSpecificDetails[i]?.file !== '' && response?.palletSpecificDetails[i]?.file !== "Custom Spec Upload") {
                    const fileObject =
                    {
                      label: response?.palletSpecificDetails[i]?.file,
                      value: response?.palletSpecificDetails[i]?.file,
                    }
                    filesArr.push(fileObject)
                  } else {
                    if (response?.palletSpecificDetails[i]?.file !== '' && response?.palletSpecificDetails[i]?.file !== "Custom Spec Upload") {
                      const fileObject =
                      {
                        label: response?.palletSpecificDetails[i]?.file,
                        value: response?.palletSpecificDetails[i]?.file,
                      }
                      filesArr.push(fileObject)
                    }
                  }
                }

                if (response?.palletSpecificDetails[i]?.image) {
                  const productImgObject =
                  {
                    fileName: response?.palletSpecificDetails[i]?.image,
                    orignalFileName: response?.palletSpecificDetails[i]?.image,
                  }
                  setDefaultPostImage(productImgObject)
                }
              }

              if (response?.palletSpecificDetails.length - 1 === i) {
                const gradeNames = gradeArr.map(val => val.value)
                const gradeListFilter = gradeArr.filter(({ value }, index) => !gradeNames.includes(value, index + 1))
                setGradeList(gradeListFilter)
                // gradeCallBack(gradeListFilter)

                if (gradeListFilter.length === 0) {
                  const filesNames = filesArr.map(val => val.value)
                  const fileListFilter = filesArr.filter(({ value }, index) => !filesNames.includes(value, index + 1))
                  setUploadImage(fileListFilter)
                  setUploadSpectState(fileListFilter)
                }
              }
            }
          }}
        />
      </div>
    );
  };

  let fileArr = [];
  const uploadSpecificationFiles = (props, flag) => {
    // let flag = false
    if (props?.values?.grade === "Custom" || props?.values?.size === "Custom") {
      flag = true
    }
    return (
      <div className="stepUpload request-order-upload-section" style={{ "margin-top": "15px" }}>
        <UploadSpecificationPTPLUS
          acceptFiles={"image/png,image/jpeg,image/gif,image/GIF,application/pdf,application/PDF,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          }
          name="uploadSpecification"
          btnName={"Upload Specification"}
          mandatory={"Star"}
          props={props}
          fileArr={fileArr}
          callBackFun={(imageArr) => {
            setFilesArr(imageArr);
          }}
        />
      </div>)
  }
  const grade = (props) => {
    return (
      <div className="app-input-text mb-26">
        <Select
          name="grade"
          data={getGradeList}
          placeholder={"Grade"}
          disabled={getGradeList.length === 0 || props?.values?.size === "Custom" ? true : false}
          searchable={true}
          onChangeHandler={(val) => {
            if (props.values.condition3) {
              setIsHeatTreared(false)
            } else {
              setIsHeatTreared(true)
            }
            uploadSpecificationFiles(props, false)

            let filesArr = []
            let conditionTypes = []
            if (props?.values?.condition0) {
              conditionTypes.push("recycled")
            }
            if (props?.values?.condition1) {
              conditionTypes.push("newCondition")
            }
            if (props?.values?.condition2) {
              conditionTypes.push("combo")
            }
            if (props?.values?.condition3) {
              conditionTypes.push("cores")
            }

            const selectedMaterial = props?.values?.material.toLowerCase()
            let palletType = props?.values?.palletType.toLowerCase()
            if (palletType === "europallet") {
              palletType = "euroPallet"
            }

            let response = palletDetailResponse[selectedMaterial].condition[conditionTypes[0]][palletType]
            for (let i = 0; i < response?.palletSpecificDetails.length; i++) {

              if (response?.palletSpecificDetails[i].size === props?.values?.size) {

                if (val.value === response?.palletSpecificDetails[i]?.grade) {
                  if (response?.palletSpecificDetails[i]?.file !== '' && response?.palletSpecificDetails[i]?.file !== "Custom Spec Upload") {
                    const fileObject =
                    {
                      label: response?.palletSpecificDetails[i]?.file,
                      value: response?.palletSpecificDetails[i]?.file,
                    }

                    filesArr.push(fileObject)
                  }

                  if (response?.palletSpecificDetails[i]?.image) {
                    const productImgObject =
                    {
                      fileName: response?.palletSpecificDetails[i]?.image,
                      orignalFileName: response?.palletSpecificDetails[i]?.image,
                    }
                    setDefaultPostImage(productImgObject)
                  }
                }
              }

              if (response?.palletSpecificDetails.length - 1 === i) {
                const filesNames = filesArr.map(val => val.value)
                const fileListFilter = filesArr.filter(({ value }, index) => !filesNames.includes(value, index + 1))
                setUploadImage(fileListFilter)
                setUploadSpectState(fileListFilter)
              }

            }
          }}
        />
      </div>
    );
  };
  const customFields = () => {
    return (
      <div className="col-12 text-left mb-40 pl-0 mt-3" style={{ "padding-top": "30px" }}>
        <div className="row material-fields-styles">
          <div className="col-md-4 col-sm-6">
            <div className="app-input-text">
              <NumberInput
                name="length"
                placeholder="Length*"
                maxLength={5}
                showErrorMessages={true}
              />
            </div>
          </div>
          <div className="col-md-4 col-sm-6">
            <div className="app-input-text">
              <NumberInput
                name="width"
                placeholder="Width*"
                maxLength={5}
                showErrorMessages={true}
              />
            </div>
          </div>
          <div className="col-md-4 col-sm-6">
            <div>
              <NumberInput
                name="height"
                placeholder="Height*"
                maxLength={5}
                onChangeHandler={() => { }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  const isHeatTreated = () => {
    return (
      <div className="col-12 text-left">
        <div className="row">
          <CheckboxInput
            name={"isHeatTreared"}
            label="Heat Treated"
            handleSelect={() => {
            }}
          />
        </div>
      </div>
    )
  }
  const defaultAttachedSpectFiles = () => {
    return (
      <div className="col-12 mb-2 max-3-row">
        {uploadImageStage.map((item, index) => (
          <div className="row mb-1" key={index}>

            <UploadSpec
              className="upload col-12"
            >
              <img
                src={UploadDummy}
                alt="upload Dummy"
              />
              <TooltipMaterial
                placement="top"
                arrow
                title={item?.value}
                enterTouchDelay={0}
              >
                <span onClick={() => {
                  generatePdfDocument(item?.value)
                }}>{item?.value}</span>
              </TooltipMaterial>

            </UploadSpec>
          </div>
        ))
        }
      </div >
    );

  }
  const generatePdfDocument = async (imagePath) => {
    const fileUrl = process.env.REACT_APP_PT_PLUS_API_URL + 'ptms/s3/get_file/' + imagePath
    window.open(fileUrl)

    // const url = window.URL.createObjectURL(new Blob([fileUrl]));
    // const link = document.createElement("a");
    // link.href = url;
    // link.setAttribute("download", "Download SpecFile.pdf");
    // document.body.appendChild(link);
    // link.click();
  };

  const formFields = (props, isValid, dirty, setFieldValue) => {
    return (
      <>
        <Form className="form-wrapper">
          <FormWrapper>

            <div>
              <InputFieldsWrapper>
                <div>
                  <div className="label-heading">
                    <p>Location Name & Address</p>
                  </div>
                  <div className="clone-outer-wrapper">
                    <div className="clone-order-wrapper mb-20 mt-9">
                      <CheckboxInput
                        name="cloneOrder"
                        label="Clone a Previous Order"
                        onChange={(val) => {
                          setCloneOrderFlag(val)
                        }}
                      />
                      {iIcon('cloneOrderInfo', 'Input a reference number from a previous order to duplicate those requirements in the below form.')}
                      {/* <MaterialToolTip title={"Input a reference number from a previous order to duplicate those requirements in the below form."} class="passwordIcon" infoIcon={true} /> */}
                    </div>
                    {cloneOrderFlag && <div className=" mb-20">
                      <TextInput
                        name="orderId"
                        maxLength={50}
                        placeholder="Enter Reference ID*"
                        blurHandler={(val) => {
                          setLocationListResponse()
                          if (val)
                            orderRefNumberAPI(val, props, setFieldValue,)
                        }}
                      />
                    </div>}
                  </div>


                  {/* <div className="business-name-wrapper">
                    <div className="mb-20" style={{ width: "300px" }}>
                      <DropDown
                        name="companyName"
                        data={companyNameResponse}
                        searchDropDown={companyName}
                        searchable={true}
                        placeholder="Select Company Name*"
                        onChangeHandler={(data) => {
                          getLocationAddress(data?.value)
                          setSelectCompanyName(data.value)                               
                          let arr = [];
                          if(data?.arrList.length !== 0){
                            for (let i = 0; i < data?.arrList.length; i++) {
                              let obj = {
                                label: data?.arrList[i].locationName,
                                value: data?.arrList[i].locationId,
                              };
                              arr.push(obj);
                              if (i === data?.arrList.length - 1) {
                                setLocationListResponse(arr)
                              }
                            }
                          }
                        }}
                      />
                    </div>
                  </div> */}

                  <div className="business-name-wrapper">
                    <div className="app-input-text mb-20" style={{ width: "300px", "margin-bottom": "22px" }}>
                      <DropDown
                        name="companyName"
                        data={companyNameResponse}
                        searchDropDown={companyName}
                        searchable={true}
                        placeholder="Select Company Name*"
                        onChangeHandler={(data) => {
                          getLocationAddress(data?.value)
                          setSelectCompanyName(data.value)
                          let arr = [];
                          if (data?.arrList.length !== 0) {
                            for (let i = 0; i < data?.arrList.length; i++) {
                              let obj = {
                                label: `${data?.arrList[i].locationName} - ${data?.arrList[i].city}, ${data?.arrList[i].state}, ${data?.arrList[i].zip}`,
                                value: data?.arrList[i].locationId,
                              };
                              arr.push(obj);
                              if (i === data?.arrList.length - 1) {
                                setLocationListResponse(arr)
                              }
                            }
                          }
                        }}
                      />
                    </div>
                    <div className="app-input-text mb-20" style={{ width: "300px", "margin-bottom": "22px" }}>
                      {/* <p>Business Name<span className="star">*</span></p> */}
                      <DropDown
                        name="businessName"
                        data={locationListResponse ? locationListResponse : companyNameResponse ? companyNameResponse : businessNameList}
                        searchDropDown={locationName}
                        searchable={true}
                        placeholder="Business Name*"
                        // -disabled={urlObject?.id ? true : false}
                        onChangeHandler={(data) => {
                          setLocationName(data.value)
                          for (let i = 0; i < getLocationAddressState.length; i++) {
                            if (data.value === getLocationAddressState[i].locationId) {
                              setLocationAddress(getLocationAddressState[i].address)
                            }
                          }
                        }}
                      />
                    </div>

                    <div className="equipment-requirements-wrapper mb-20">
                      <div className="label-heading">
                        <p>Equipment Requirements (Select all that apply)<span className="star">*</span></p>
                      </div>
                      <div className="requirements-checkbox pl-0">
                        {equipmentList?.map((value, index) => (
                          <CheckboxInput
                            name={"equipment" + index}
                            label={equipmentList[index]}
                            key={index}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="label-heading"><p>Pallet Details<span className="star">*</span></p></div>
                    <div className="col-12 pl-0" style={{ "padding-bottom": "30px" }}>
                      <div className="row">
                        {materialDiv(setFieldValue)}
                        <div className="col-7">
                          {materialResponse === "WOOD" && conditions(setFieldValue, woodConditions)}
                          {materialResponse === "PLASTIC" && conditions(setFieldValue, plasticConditions)}
                          {props.values?.condition1 && materialResponse === "WOOD" && hardOrSoftWoodDiv(setFieldValue)}
                        </div>
                      </div>
                    </div>

                    <div className="col-12 pl-0">
                      <div className="row material-fields-styles">
                        <div className="col-md-3">
                          {materialResponse === "WOOD" && palletType(props, setFieldValue)}
                        </div>
                        <div className="col-md-3">
                          {materialResponse === "WOOD" && moisture(props, setFieldValue)}
                        </div>
                        <div className="col-md-3">
                          {materialResponse === "WOOD" && size(props, setFieldValue)}
                        </div>
                        <div className="col-md-3">
                          {materialResponse === "WOOD" && grade(props, setFieldValue)}
                        </div>
                      </div>
                    </div>

                    {(materialResponse !== "WOOD" || props?.values?.size === "Custom") && customFields(props)}

                    {isHeatTrearedFlag && isHeatTreated(props)}

                    {uploadSpecificationFiles(props, false)}
                    {uploadImageStage && defaultAttachedSpectFiles()}

                    {/* temporarily hidden dont delete */}
                    {/* <div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <button className={(props.values.recurringCheckBoxFlag || recurringModal) ? 'rec-button-selected-style' : 'rec-button-unselected-style'}
                          onClick={() => setRecurringModal(true)}
                        >Setup Recurring Order</button>
                        {props.values.recurringCheckBoxFlag &&
                          <div style={{ marginLeft: '20px' }}>
                            <p style={{ fontSize: '13px', color: '#005586', fontWeight: 'bold', marginBottom: '0px' }}>Recurring Summary</p>
                            <p style={{ fontSize: '12px', height: '15px', marginTop: '0px' }}>{frameRecurringOrderSummary(props.values)}
                              <img className='rec-close-icon-style' src={CloseIcon} alt="close-icon" onClick={() => removeRecurringSettingFunction(props.setFieldValue)} /></p>
                          </div>
                        }
                      </div>
                      {recurringModal &&
                        <RecurringOrderModal
                          setFieldValueFunction={(fieldName, fieldValue) => {
                            props.setFieldValue(fieldName, fieldValue)
                          }}
                          formikValues={props.values}
                          toggleModal={(type) => {
                            setRecurringModal(false)
                            if (type === 'submit') props.setFieldValue('recurringCheckBoxFlag', true)
                          }}
                        />}
                    </div> */}

                    {/* {loadDetails(props, setFieldValue)} */}
                    <LoadDetails props={props} maxQuantityState={maxQuantityState} editResponse={editResponse} modifyRequestFlag={false} callBack={(value) => {
                      setQuantityValueState(value)
                    }} loadsCallBack={(data) => {
                      setLoadDetailsState(data)
                    }} />
                  </div>
                  <div className="label-heading mt-3">
                    <p>Remarks</p>
                  </div>
                  <div className="col-12">
                    <div className="row">
                      <TextArea
                        name='remark'
                        maxLength='200'
                        showErrorMessages={true}
                      />
                    </div>
                  </div>
                </div>
              </InputFieldsWrapper>
            </div>

            <Footer>
              <Button
                type="app-green-button"
                handleClick={() => {
                  formSubmit(props)
                }}
                disabled={!(isValid && dirty)}
              >
                Submit Request
              </Button>
            </Footer>

          </FormWrapper>
        </Form>
      </>
    );
  };

  if (!storedData?.data?.isEnablePtPlusFeature) {
    dispatch(logoutClearRedux());
    localStorage.clear();
    history.push('/sign-in')
    window.location.reload(false);
  }

  return (
    <Layout pageType="PtPlusPage" topBarViewMobile={'hide'}>
      {loaderVisible && <Spinner />}
      <div>
        <div style={{ width: '100%', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px 0px' }}>
          <TopHeader>
            <h6>Request Order</h6>
          </TopHeader>
        </div>
        <Container>
          <Wrapper>
            <Formik
              //enableReinitialize={true}
              initialValues={getPostInitialValues()}
              validationSchema={VALIDATION_SCHEMA()}
              onSubmit={() => { }}
            >
              {(props) => {
                const { isValid, dirty, setFieldValue } =
                  props;

                return (
                  <>
                    {formFields(props, isValid, dirty, setFieldValue)}
                  </>
                );
              }}
            </Formik>
          </Wrapper>
          <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title={modalTitle}
            content={modalContent}
            link={modalLink}
            alertType={alertType}
            className="alert-msg-container"
            InnerClassName="alert-msg"
            callBackAlert={(val) => {
              if (val === "success") history.push('/ptplus-order-details')
              else toggleModal()
            }}
          />
        </Container>

      </div>
    </Layout>
  )
};

export default OrderRequest;

const HardSoftWoodWrapper = styled.div`
  margin-left: 15px;
  margin-top: 10px;
  width: 275px;
  .radio-checkmark{
      width: 18px;
      height: 18px;
      border-radius: 0px;
    }
  .radio-checkmark:after {
    top: 2px;
    left: 2px;
    width: 12px;
    height: 12px;
    border-radius: 0px;
  }
  .radio-container {
    span {
      white-space : nowrap;
    }
  }
`
